import {FC, Card, PropsWithChildren, useMemo} from 'external/react'
import Icon from 'external/fortawesome'
import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'
import useAdmin from 'context/admin-context/hook'

const ClientContainer: FC<PropsWithChildren> = props => {
  const { children } = props;
  const { state } = useAdmin();
  const { profile } = state.client;

    const { roleName } = useAdmin();
    const backPath = useMemo(() => `/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients`, [roleName])

  return (
    <BasicLayout>
      <Card.Header className='card--header d-flex align-items-center'>
        <div className='d-flex flex-column justify-content-center'>
          <ButtonBack path={backPath} />
        </div>

        <div className='ms-2 d-flex align-items-center' style={{ fontSize: '31px' }}>
          <Icon name='faUser' />
        </div>

        <div className='ms-2 d-flex flex-column justify-content-center'>
          <span className='text-capitalize fw-semibold' style={{ fontSize: '1.1rem', lineHeight: 1.2 }}>
            {profile?.name}
          </span>
          {profile?.email && (
            <a href={`mailto:${profile.email}`} className='text-muted' style={{ fontSize: '0.8rem' }}>
              {profile.email}
            </a>
          )}
        </div>
        <div className='ms-auto d-flex align-items-center gap-2'>
          <span
            className={`badge ${profile?.purchases > 0 ? 'bg-success' : 'bg-secondary'}`}
            style={{ fontSize: '0.85rem', padding: '6px 12px' }}
          >
            {profile?.domain}
          </span>
        </div>
       </Card.Header>
      {children}
    </BasicLayout>
  );
};

export default ClientContainer;